import { Injectable } from '@angular/core';

import { DictionaryItem } from '@hglobal/fin-ui';
import { delay, Observable, of } from 'rxjs';

import { GetTransactionsRes, SaveCommentRes } from '../models';
import { getMonthlyRepYearsMock, getTransactionsMock } from './index';
import { TransactionsApiService } from '../api';

@Injectable()
export class TransactionsMockApiService extends TransactionsApiService {
  override getTransactions(): Observable<GetTransactionsRes> {
    const transactions = getTransactionsMock(18);

    return of({ itemsCount: transactions.length, transactions }).pipe(delay(500));
  }

  override getMonthlyRepYears(): Observable<DictionaryItem<string>[]> {
    return of(getMonthlyRepYearsMock()).pipe(delay(500));
  }

  override saveComment(): Observable<SaveCommentRes> {
    return of(undefined).pipe(delay(500));
  }
}
